package com.ustadmobile.util

data class EmptyList(var text: String? = null, var icon: String? = null)